<template>
  <page :title="$tc('collection._name')">
    <div slot="page-header-right">

      <button class="button is-primary" @click="create">
        <b-icon icon="plus"></b-icon>
        <span>
            <slot>{{ $tc('add.collection') }}</slot>
          </span>
      </button>
    </div>

    <div class="box">
      <b-tabs>
        <b-tab-item label="Magazine">
          <magazine-collection ref="magazine"></magazine-collection>
        </b-tab-item>

        <b-tab-item label="Issue">
          <issue-collection ref="issue"></issue-collection>
        </b-tab-item>

        <b-tab-item label="Feed">
          <feed-collection ref="feed"></feed-collection>
        </b-tab-item>
      </b-tabs>
    </div>
  </page>
</template>

<script>

import AddNewCollector from "../../../../modules/admin/pages/collections/components/AddNewCollector";
import IssueCollection from "./components/IssueCollection";
import MagazineCollection from "./components/MagazineCollection";
import FeedCollection from "./components/FeedCollection";

export default {
  components: {
    IssueCollection,
    MagazineCollection,
    FeedCollection
  },

  methods: {
    create() {
      this.$buefy.modal.open({
        component: AddNewCollector,
        props: {
          added: (data) => this.$refs[data.type].reload(),
        },
      });
    },
  }
};
</script>
